import { Vector3 as t, Quaternion as n, Matrix4 as e } from "three";
import { getQuaternion as a } from "./index13.js";
const c = new t(), i = new n(), s = new t(1, 1, 1);
function u(o, r = new e()) {
  return r.compose(
    c.fromArray(o.pos),
    a(o, i),
    s
  );
}
export {
  u as getMatrix
};
//# sourceMappingURL=index9.js.map
